import { render, staticRenderFns } from "./roi-layer.vue?vue&type=template&id=15028152&scoped=true&"
import script from "./roi-layer.vue?vue&type=script&lang=ts&"
export * from "./roi-layer.vue?vue&type=script&lang=ts&"
import style0 from "./roi-layer.vue?vue&type=style&index=0&id=15028152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15028152",
  null
  
)

export default component.exports